// extracted by mini-css-extract-plugin
export default {"navLogo":"NavLogo_navLogo__ajvIw","logoTextContainer":"NavLogo_logoTextContainer__dZoD8","logoText":"NavLogo_logoText__wG6Yw"};